import { render } from "./bindingPhone.vue?vue&type=template&id=3ea880ce&scoped=true&ts=true&lang=pug"
import script from "./bindingPhone.vue?vue&type=script&lang=ts"
export * from "./bindingPhone.vue?vue&type=script&lang=ts"

import "./bindingPhone.vue?vue&type=style&index=0&id=3ea880ce&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea880ce"]])

export default __exports__